export default () => ({
  currentCampaign: null
})
